/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryGa4DailyReportRowData
 */
export interface GoogleBigQueryGa4DailyReportRowData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    events?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    sessions?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchases?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    transactions?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenue?: string;
}

/**
 * Check if a given object implements the GoogleBigQueryGa4DailyReportRowData interface.
 */
export function instanceOfGoogleBigQueryGa4DailyReportRowData(value: object): value is GoogleBigQueryGa4DailyReportRowData {
    return true;
}

export function GoogleBigQueryGa4DailyReportRowDataFromJSON(json: any): GoogleBigQueryGa4DailyReportRowData {
    return GoogleBigQueryGa4DailyReportRowDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4DailyReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4DailyReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'events': json['events'] == null ? undefined : json['events'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'purchases': json['purchases'] == null ? undefined : json['purchases'],
        'transactions': json['transactions'] == null ? undefined : json['transactions'],
        'purchaseRevenue': json['purchaseRevenue'] == null ? undefined : json['purchaseRevenue'],
    };
}

export function GoogleBigQueryGa4DailyReportRowDataToJSON(json: any): GoogleBigQueryGa4DailyReportRowData {
    return GoogleBigQueryGa4DailyReportRowDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4DailyReportRowDataToJSONTyped(value?: GoogleBigQueryGa4DailyReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'events': value['events'],
        'sessions': value['sessions'],
        'purchases': value['purchases'],
        'transactions': value['transactions'],
        'purchaseRevenue': value['purchaseRevenue'],
    };
}

